module.exports = __webpack_public_path__ + "assets/img/7_1521.286b33fe.jpg";